"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RuleLinkWithContext = exports.RuleLink = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_easy_emoji_1 = __importDefault(require("react-easy-emoji"));
const react_router_dom_1 = require("react-router-dom");
const publicodes_1 = require("publicodes");
const contexts_1 = require("./contexts");
const { encodeRuleName } = publicodes_1.utils;
function RuleLink(_a) {
    var { dottedName, engine, documentationPath, displayIcon = false, children } = _a, props = __rest(_a, ["dottedName", "engine", "documentationPath", "displayIcon", "children"]);
    const rule = engine.getRule(dottedName);
    const newPath = documentationPath + '/' + encodeRuleName(dottedName);
    // There is a problem with this line of code : we loose the information
    // about the applicability of the formula. Besides, when we are not in the context of the
    // rules which defines the reference, we want to print a link to the parent rule and not
    // the value directly.
    // Besides, sometimes nodes don't have formula (which makes the doc page crash)
    // Furthermore, nothing prevent from using a type notification as a reference
    // For all these reason, I'm advocating for a change of perspective inside this notion of ruleWithDedicatedDocumentationPage
    // if (!ruleWithDedicatedDocumentationPage(rule)) {
    // 	return <Explanation node={engine.evaluate(rule.dottedName).formule} />
    // }
    if (!rule) {
        throw new Error(`Unknown rule: ${dottedName}`);
    }
    return (jsx_runtime_1.jsxs(react_router_dom_1.Link, Object.assign({ to: newPath }, props, { children: [children || rule.title, ' ', displayIcon && rule.rawNode.icônes && (jsx_runtime_1.jsxs("span", { children: [react_easy_emoji_1.default(rule.rawNode.icônes), " "] }, void 0))] }), void 0));
}
exports.RuleLink = RuleLink;
function RuleLinkWithContext(props) {
    const engine = react_1.useContext(contexts_1.EngineContext);
    if (!engine) {
        throw new Error('an engine should be provided in context');
    }
    const documentationPath = react_1.useContext(contexts_1.BasepathContext);
    return (jsx_runtime_1.jsx(RuleLink, Object.assign({ engine: engine, documentationPath: documentationPath }, props), void 0));
}
exports.RuleLinkWithContext = RuleLinkWithContext;
